"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hooks = require("@nicbase/hooks");

var _nicbaseReducers = require("nicbase-reducers");

var _nicbaseTranslation = require("nicbase-translation");

var _filterChips = _interopRequireDefault(require("../filter-chips"));

var _filterableSelectionList = _interopRequireDefault(require("../filterable-selection-list"));

var _excluded = ["selectedRows"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var sort = function sort(prev, next) {
  var _prev$label;

  return String((_prev$label = prev.label) !== null && _prev$label !== void 0 ? _prev$label : '').localeCompare(next.label);
};

var AssetGroupSelectionList = function AssetGroupSelectionList(props) {
  var _usePortal = (0, _nicbaseReducers.usePortal)(),
      portalId = _usePortal.id;

  var _usePortalAssetGroups = (0, _hooks.usePortalAssetGroups)(portalId, {
    enabled: Boolean(portalId),
    select: function select(groups) {
      return groups.map(function (_ref) {
        var id = _ref.id,
            name = _ref.name;
        return {
          value: id,
          label: name
        };
      }).sort(sort);
    }
  }),
      assetGroups = _usePortalAssetGroups.data;

  return /*#__PURE__*/_react["default"].createElement(_filterableSelectionList["default"], _extends({}, props, {
    data: assetGroups,
    filterInputLabel: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "filters.searchAssetGroup"
    })
  }));
};

var AssetGroupChips = function AssetGroupChips(_ref2) {
  var selectedRows = _ref2.selectedRows,
      other = _objectWithoutProperties(_ref2, _excluded);

  var _usePortal2 = (0, _nicbaseReducers.usePortal)(),
      portalId = _usePortal2.id;

  var _usePortalAssetGroups2 = (0, _hooks.usePortalAssetGroups)(portalId, {
    enabled: Boolean(portalId),
    select: function select(groups) {
      return groups.map(function (_ref3) {
        var id = _ref3.id,
            name = _ref3.name;
        return {
          value: id,
          label: name
        };
      }).sort(sort);
    }
  }),
      assetGroups = _usePortalAssetGroups2.data;

  var chipData = selectedRows.map(function (value) {
    return assetGroups === null || assetGroups === void 0 ? void 0 : assetGroups.find(function (assetGroup) {
      return assetGroup.value === value;
    });
  }).filter(function (group) {
    return group;
  });
  return /*#__PURE__*/_react["default"].createElement(_filterChips["default"], _extends({}, other, {
    data: chipData
  }));
};

AssetGroupChips.propTypes = _objectSpread(_objectSpread({}, _filterChips["default"].propTypes), {}, {
  selectedRows: _propTypes["default"].arrayOf(_propTypes["default"].number)
});
AssetGroupChips.defaultProps = _objectSpread(_objectSpread({}, _filterChips["default"].defaultProps), {}, {
  selectedRows: []
});
AssetGroupSelectionList.Chips = AssetGroupChips;
var _default = AssetGroupSelectionList;
exports["default"] = _default;